<p [innerHtml]="'VERIFY_CONTACT.CAPTION'|translate"></p>
<app-form-field [label]="'VERIFY_CONTACT.OTP'|translate"
                [settings]="settings.fieldsSettings.otp"
                [value]="valuesForInput.otp"
                (modelChange)="updateCurrentValue('otp',$event)"
                [specifiedAttributes]="specifiedAttributes.otp"
                (enterPressure)="submit()">
</app-form-field>
<div class="layout horizontal right middle"  style="margin-bottom: 20px">
    <span *ngIf="preventMultipleOtpRequests" class="info" style="text-align: end;">{{'VERIFY_CONTACT.OTP_SENT'|translate}}</span>
    <span *ngIf="!preventMultipleOtpRequests" class="link" style="text-align: end;" (click)="requireNewOtp()">{{'VERIFY_CONTACT.UNRECEIVED_OTP'|translate}}</span>
</div>
<div class="layout horizontal space-between">
    <app-button-set align="left">
        <app-button [label]="'VERIFY_CONTACT.CANCEL'|translate" icon="arrow-left" (click)="cancel()" [disabled]="formSubmitting"></app-button>
    </app-button-set>
    <app-button-set align="right">
        <app-button [label]="'VERIFY_CONTACT.SEND'|translate" primary="true" icon="check" (click)="submit()" [disabled]="someErrors || formSubmitting"></app-button>
    </app-button-set>
</div>